import { useEffect } from "react";
import { API_ENDPOINT, APP_ID } from "../utils/constants";
import { getDbHeader } from "../utils/util";

function MetaPixelLoader() {
  useEffect(() => {
    async function initializeMetaPixel() {
      try {
        const response = await fetch(
          `${API_ENDPOINT}/event/get-meta-pixel-config`,
          {
            ...getDbHeader(APP_ID),
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }

        const data = await response.json();

        const pixelId = data?.metaPixel?.pixelId;

        if (!pixelId || typeof pixelId !== "string") {
          throw new Error("Invalid or missing Meta Pixel ID");
        }

        // 1. Initialize fbq function (mirrors the official snippet)
        if (!window.fbq) {
          const fbq = function () {
            fbq.callMethod
              ? fbq.callMethod.apply(fbq, arguments)
              : fbq.queue.push(arguments);
          };

          if (!window._fbq) window._fbq = fbq;
          fbq.push = fbq;
          fbq.loaded = true;
          fbq.version = "2.0";
          fbq.queue = [];
          window.fbq = fbq;
        }

        // 2. Load fbevents.js script
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://connect.facebook.net/en_US/fbevents.js";

        script.onload = () => {
          console.log(`Meta Pixel loaded successfully for ID: ${pixelId}`);
        };

        script.onerror = () => {
          throw new Error("Failed to load fbevents.js script");
        };

        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);

        // 3. Init pixel and track PageView
        window.fbq("init", pixelId);

        if (data?.metaPixel?.trackPageView !== false) {
          window.fbq("track", "PageView");
        }

        // 4. Noscript fallback
        const noscript = document.createElement("noscript");
        const img = document.createElement("img");
        img.height = 1;
        img.width = 1;
        img.style.display = "none";
        img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
        noscript.appendChild(img);
        document.body.appendChild(noscript);
      } catch (error) {
        console.error("Meta Pixel initialization error:", error.message);
      }
    }

    initializeMetaPixel();
  }, []);

  return null;
}

export default MetaPixelLoader;
